/** RBAC v1 Cognito group slugs (slug = group name in User Pool). */

export const RBAC_GROUP_ADMINISTRATOR = "administrator";

export const RBAC_GROUP_TICKET_VIEWER = "ticket-viewer";



/** @deprecated Legacy Cognito group — no longer used for access checks. */

export const COGNITO_GROUP_ADMIN = "admin";

/** @deprecated Legacy Cognito group — no longer used for access checks. */

export const COGNITO_GROUP_USER = "user";



/**

 * @param {string[] | string | undefined} raw — ID token `cognito:groups` claim

 * @returns {string[]}

 */

export function normalizeCognitoGroups(raw) {

  if (!raw) return [];

  if (Array.isArray(raw)) return raw.map(String).filter(Boolean);

  if (typeof raw === "string") return [raw];

  return [];

}



/**

 * Platform administrator (RBAC slug only — legacy `admin` is not treated as admin).

 * @param {string[]} groups

 * @returns {boolean}

 */

export function isAdminFromGroups(groups) {

  return (groups || []).includes(RBAC_GROUP_ADMINISTRATOR);

}



/**

 * Primary Halo role label for UI (administrator → admin, ticket-viewer/operator → user).

 * @param {string[]} groups

 * @returns {'admin' | 'user' | null}

 */

export function resolvePrimaryRole(groups) {

  if (isAdminFromGroups(groups)) return "admin";

  if (

    (groups || []).some((g) =>

      [RBAC_GROUP_TICKET_VIEWER, "ticket-operator", COGNITO_GROUP_USER].includes(g),

    )

  ) {

    return "user";

  }

  return null;

}



/**

 * @param {Record<string, unknown>} payload — decoded Cognito ID token

 * @returns {{ email: string, sub: string, username: string, groups: string[], role: 'admin' | 'user' | null }}

 */

export function userFromIdTokenPayload(payload) {

  const groups = normalizeCognitoGroups(payload["cognito:groups"]);

  return {

    email: String(payload.email || payload["cognito:username"] || ""),

    sub: String(payload.sub || ""),

    username: String(payload["cognito:username"] || payload.sub || ""),

    groups,

    role: resolvePrimaryRole(groups),

  };

}

/**
 * Entra access token + UI `roles` from login/refresh JSON (or the JWT `roles` claim).
 * @param {Record<string, unknown> | null | undefined} payload
 * @param {string[] | undefined} roles
 */
export function userFromEntraClaims(payload, roles) {
  const groups = normalizeCognitoGroups(
    roles?.length ? roles : payload?.roles,
  );
  const email = String(
    payload?.preferred_username || payload?.upn || payload?.email || "",
  );
  const sub = String(payload?.oid || payload?.sub || "");
  return {
    email,
    sub,
    username: email || sub,
    groups,
    role: resolvePrimaryRole(groups),
  };
}



/**

 * Local dev when Cognito env is unset (see cognitoPool.isLocalDevBypassEnabled).

 * @param {string} [email]

 * @returns {ReturnType<typeof userFromIdTokenPayload>}

 */

export function buildDevBypassUser(email) {

  const roleEnv = (process.env.REACT_APP_DEV_BYPASS_ROLE || "user").toLowerCase();

  const isAdminRole = roleEnv === "admin";

  const groups = isAdminRole

    ? [RBAC_GROUP_ADMINISTRATOR]

    : [RBAC_GROUP_TICKET_VIEWER];

  const resolvedEmail = (email || "").trim() || "dev@localhost";

  return {

    email: resolvedEmail,

    sub: "local-dev-bypass",

    username: "local-dev-bypass",

    groups,

    role: isAdminRole ? "admin" : "user",

  };

}

